<template>
    <div>
        <v-card elevation="0">
            <v-card color="#80CBC4" elevation="0" height="100px" class="d-flex align-content-end">
                <v-card-title class="white--text text-h5">
                    <v-icon color="white" large>mdi-bullhorn-outline</v-icon>
                    &nbsp;Announcement
                </v-card-title>
            </v-card>
            <Announcement />
        </v-card>
        <iframe name="hiddenFrame" hidden></iframe>
    </div>
</template>
<script>
import Announcement from "../../../components/Admin/Settings/Announcement/Manager.vue"
export default {
    components: {
        Announcement
    }
}
</script>